import React from 'react';
import "./pageNews.css";
import { useTranslation } from "react-i18next";

function PageNews() {
    const { t, i18n } = useTranslation();
    const language = i18n.language;


    // Data formatada de acordo com o idioma
    const currentDate = new Date().toLocaleDateString(language === "en" ? "en-US" : "pt-BR", {
        year: 'numeric',
        month: 'long',
    });

    return (
        <div className="d-flex row m-0 justify-content-center">
            <div className="content-container col-lg-8">
                <p className="text-muted TextAboutUsContactUs mt-5">{currentDate}</p>
                <h2 className="TextAboutUsContactUs">{t("pageNews.title")}</h2>
            </div>
        </div>
    );
}

export default PageNews;

